export default "__VITE_ASSET__D7DAZw3d__"